import { Marca } from "./Marca"
import { Navegacao } from "./Navegacao"

// O esqueleto desenha a forma da página que vai chegar, em vez de anunciar a espera por escrito.
// É deliberado: "Carregando…" pede que a pessoa leia para descobrir que nada aconteceu ainda,
// enquanto o contorno já diz o que vem — quatro números em cima, blocos embaixo — e a espera passa
// a parecer progresso.
//
// `aria-busy` com o rótulo é o que sobra para quem usa leitor de tela, que não enxerga a forma.
const Bloco = ({ className }: { className: string }) => (
    <span className={`block rounded bg-sunk ${className}`} />
)

const Cartao = () => (
    <div className="rounded-lg border border-line bg-card p-4">
        <Bloco className="h-3 w-2/3" />
        <Bloco className="mt-3 h-7 w-1/2" />
        <Bloco className="mt-3 h-3 w-4/5" />
    </div>
)

const Painel = () => (
    <div className="rounded-lg border border-line bg-card p-5">
        <Bloco className="h-4 w-1/3" />
        <Bloco className="mt-2 h-3 w-1/2" />
        <div className="mt-5 space-y-3">
            <Bloco className="h-6 w-full" />
            <Bloco className="h-6 w-5/6" />
            <Bloco className="h-6 w-2/3" />
            <Bloco className="h-6 w-1/2" />
        </div>
    </div>
)

export const Carregando = () => (
    <main className="mx-auto max-w-5xl px-4 py-8">
        <Marca />
        <Navegacao />
        <div
            aria-busy="true"
            aria-live="polite"
            aria-label="Carregando os dados da sua empresa"
            // A animação inteira mora num nó só: quem pediu menos movimento no sistema fica com o
            // mesmo desenho, parado, e não com uma página em branco.
            className="animate-pulse motion-reduce:animate-none"
        >
            <div className="mb-6">
                <Bloco className="h-7 w-3/4 max-w-lg" />
                <Bloco className="mt-3 h-4 w-1/2 max-w-xs" />
            </div>

            <div className="mb-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
                <Cartao />
                <Cartao />
                <Cartao />
                <Cartao />
            </div>

            <div className="grid gap-4 lg:grid-cols-2">
                <Painel />
                <Painel />
            </div>
        </div>
    </main>
)
